import router from '@/router/index';
import store from '@/store';

import nprogress from 'nprogress';
import 'nprogress/nprogress.css';

nprogress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})
const noCheckList = [ '/Login', ], LoginPath = '/Login';

router.beforeEach(async (to, from, next)=>{
  nprogress.start();
  // console.log(to, from);
  const isLogin = store.getters.getIsLogin,
        routeList = store.getters['permissions/getRouteList'];
  // console.log(isLogin, routeList);
  store.commit('setHomeMap', undefined); // 跳转路由前清除之前的homeMap,防止部分组件不加载
  if(isLogin){
    if(to.path == LoginPath){
      next();
    }else{
      if(routeList.length > 0){
        next();
      }else{
        const list = await store.dispatch('permissions/initList');
        list.forEach((route, index, arr) => {
          router.addRoute(route);
        });
        if(list.length == 0){
          next(LoginPath);
        }
        if(to.path == '/404'){
          next({ ...to.redirectedFrom });
        }else{
          next({ ...to });
        }
      }
    }
  }else{
    if(noCheckList.includes(to.path)){
      next();
    }else{
      next(LoginPath);
    }
  }
});
router.afterEach(() => {
  nprogress.done();
})